import { mainSiteUrl } from '@/mocks/categories';

export default function WhatIsSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-6">
              Was ist Oopbuy Spreadsheet?
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              Ein <strong className="text-foreground-900">Oopbuy Spreadsheet</strong> ist eine strukturierte und
              st&auml;ndig aktualisierte &Uuml;bersicht &uuml;ber gepr&uuml;fte Produkte, vertrauensw&uuml;rdige
              Verk&auml;ufer und aktuelle Angebote. Es hilft dir, den &Uuml;berblick im riesigen Angebot zu
              behalten und die besten Deals zu finden.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-6">
              Egal ob du nach Sneakern, Kleidung oder Accessoires suchst – mit einem Oopbuy Spreadsheet
              sparst du Zeit, vermeidest Fehlk&auml;ufe und findest genau das, was du suchst.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300"
            >
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              Zum Oopbuy Spreadsheet
            </a>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8">
            <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-6 text-center">
              Oopbuy Spreadsheet vs. Normale Suche
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-300/60">
                    <th className="text-left py-3 px-4 font-semibold text-foreground-900">Feature</th>
                    <th className="text-center py-3 px-4 font-semibold text-primary-600 bg-primary-50/50 rounded-t-lg">
                      Oopbuy Spreadsheet
                    </th>
                    <th className="text-center py-3 px-4 font-semibold text-foreground-600">
                      Normale Suche
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-foreground-700">Datenqualit&auml;t</td>
                    <td className="text-center py-3 px-4 bg-primary-50/30">
                      <i className="ri-check-line w-5 h-5 flex items-center justify-center text-accent-600 mx-auto"></i>
                      <span className="text-xs text-accent-700">Gepr&uuml;ft</span>
                    </td>
                    <td className="text-center py-3 px-4 text-foreground-500">
                      <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-foreground-400 mx-auto"></i>
                      <span className="text-xs">Variabel</span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-foreground-700">Verk&auml;uferinformationen</td>
                    <td className="text-center py-3 px-4 bg-primary-50/30">
                      <i className="ri-check-line w-5 h-5 flex items-center justify-center text-accent-600 mx-auto"></i>
                      <span className="text-xs text-accent-700">Detailliert</span>
                    </td>
                    <td className="text-center py-3 px-4 text-foreground-500">
                      <i className="ri-close-line w-5 h-5 flex items-center justify-center text-foreground-400 mx-auto"></i>
                      <span className="text-xs">Nicht verf&uuml;gbar</span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 px-4 text-foreground-700">Aktualisierungen</td>
                    <td className="text-center py-3 px-4 bg-primary-50/30">
                      <i className="ri-check-line w-5 h-5 flex items-center justify-center text-accent-600 mx-auto"></i>
                      <span className="text-xs text-accent-700">Regelm&auml;&szlig;ig</span>
                    </td>
                    <td className="text-center py-3 px-4 text-foreground-500">
                      <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-foreground-400 mx-auto"></i>
                      <span className="text-xs">Unregelm&auml;&szlig;ig</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 text-foreground-700">Anf&auml;ngerfreundlich</td>
                    <td className="text-center py-3 px-4 bg-primary-50/30">
                      <i className="ri-check-line w-5 h-5 flex items-center justify-center text-accent-600 mx-auto"></i>
                      <span className="text-xs text-accent-700">Sehr einfach</span>
                    </td>
                    <td className="text-center py-3 px-4 text-foreground-500">
                      <i className="ri-close-line w-5 h-5 flex items-center justify-center text-foreground-400 mx-auto"></i>
                      <span className="text-xs">Komplex</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}